/**
 * @date: 12/29/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useState} from "react";
import makeStyles from '@mui/styles/makeStyles';
import Alert from '@mui/material/Alert';
import ShowMessage from "../utils/show-message";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import {DT_EMAIL} from "./portal-helper";

const useStyles = makeStyles((theme) => ({
    errorCodeWrapper: {
        textAlign: 'left', fontSize: 14, whiteSpace: 'pre-wrap'
    },
    message: {
        textAlign: 'left', fontSize: 16, whiteSpace: 'pre-wrap', margin: 0, paddingBottom: 0
    },

}));

export default function ShowInfo(props){
    const classes = useStyles();
    const {title} = props;
    const queryParam = getQueryParams();

    const contactEmail = DT_EMAIL;

    const error = queryParam && (queryParam.err || queryParam.error || queryParam.warning) || null;
    const errorCode = queryParam && (queryParam.errorCode ) || null;
    const emailBody = `${title || ""}\n\n ${error || ""}\n\nError Code: ${errorCode || ""}`;
    return (
        <div>
                <h3 className='auth-title'>{title}</h3>

                {error  && <Alert color='warning' icon={false}  >
                    <pre className={classes.message}>{error}</pre>
                </Alert>}

                {errorCode && <Alert color='warning' icon={false}  >
                    <pre className={classes.message}>Error Code: <strong>{errorCode}</strong></pre>
                </Alert>}

                <br/>
                <br/>
                <div >
                    <pre className={classes.message}>Please copy the error message above, and email it to <a target='_blank' href={`mailto:${contactEmail}?subject=${encodeURIComponent(error || title)}&body=${encodeURIComponent(emailBody)}`} >{contactEmail}</a></pre>

                </div>
        </div>

    );
}
